import { useEffect } from 'react';

interface PageMetaProps {
  title: string;
  description?: string;
  canonical?: string;
  schemaScripts?: Array<Record<string, unknown>>;
}

export default function PageMeta({ title, description, canonical, schemaScripts }: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }

    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute('href', canonical);
    }

    return () => {
      // Cleanup not needed for full page navigation, but good practice
    };
  }, [title, description, canonical]);

  useEffect(() => {
    if (!schemaScripts || schemaScripts.length === 0) return;

    const scriptIds: string[] = [];
    schemaScripts.forEach((schema, index) => {
      const scriptId = `schema-ld-${index}-${Date.now()}`;
      scriptIds.push(scriptId);
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      scriptIds.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [schemaScripts]);

  return null;
}